import { Nullable } from 'clickNgo/models/utils'
import { getFormattedFinance } from 'partner360/helpers/getFormattedFinance'

export const getQBRFormattedPercent = (
  value?: Nullable<number | string>,
  signDisplay?: 'exceptZero'
) => {
  if (value === null || value === undefined) {
    return '-'
  }

  return `${getFormattedFinance(value, {
    maximumFractionDigits: 0,
    minimumFractionDigits: 0,
    signDisplay,
  })}%`
}
